import { CHATBOX_STRINGS } from "../../types";
import "./ChatBoxHeader.scss";
import closeIcon from "../../../../appAssets/closeIcon.png";

interface ChatBoxHeaderProps {
  isChatScreen: boolean;
  onClose: () => void;
  hideClose?: boolean;
}

function ChatBoxHeader({ isChatScreen, onClose, hideClose }: ChatBoxHeaderProps) {
  return (
    <div className="chat-header">
      <div />
      <h1 className="chat-header__title">
        {isChatScreen ? CHATBOX_STRINGS.letsChat : CHATBOX_STRINGS.tellStory}
      </h1>
      {!hideClose && (
        <button
          type="button"
          className="chat-header__close"
          onClick={onClose}
          aria-label="Close"
        >
          <img src={closeIcon} alt="Close" className="chat-header__close-icon" />
        </button>
      )}
      {hideClose && <div />}
    </div>
  );
}

export default ChatBoxHeader;
